import styled from 'styled-components';
import {StyledProps} from './typings';

export const StyledSubcategory = styled.div<StyledProps>`
  margin-left: 28px;
  margin-top: -8px;
  display: ${(props) => (props.$visible ? 'flex' : 'none')};
  flex-direction: row;
  flex-wrap: wrap;
`;
